const queryOptions = (t) => [
  {
    name: 'id',
    displayName: t('queryBuilder.queryParam.queryOptions.admin.id'),
    type: 'string',
    used: false,
    value: ''
  },
  {
    name: 'name',
    displayName: t('queryBuilder.queryParam.queryOptions.admin.name'),
    type: 'groupName',
    used: false,
    value: ''
  },
  {
    name: 'createdAt',
    displayName: t('queryBuilder.queryParam.queryOptions.admin.createdAt'),
    type: 'date',
    used: false,
    value: ''
  },
  {
    name: 'isActive',
    displayName: t('queryBuilder.queryParam.queryOptions.admin.isActive'),
    type: 'select',
    values: [true, false, 'ISPRINTED', 'ISNOTPRINTED', 'ISPRINTINGDONE'],
    displayedValues: [
      t('queryBuilder.queryParam.queryOptions.admin.isActiveValues.true'),
      t('queryBuilder.queryParam.queryOptions.admin.isActiveValues.false'),
      t('queryBuilder.queryParam.queryOptions.admin.isActiveValues.ISPRINTED'),
      t('queryBuilder.queryParam.queryOptions.admin.isActiveValues.ISNOTPRINTED'),
      t('queryBuilder.queryParam.queryOptions.admin.isActiveValues.ISPRINTINGDONE')
    ],
    used: false,
    value: ''
  },
  {
    name: 'sort',
    displayName: t('queryBuilder.queryParam.queryOptions.admin.sort.title'),
    type: 'key-value',
    keys: [
      { name: 'id', displayName: t('queryBuilder.queryParam.queryOptions.admin.sort.keys.id') },
      { name: 'name', displayName: t('queryBuilder.queryParam.queryOptions.admin.sort.keys.name') }
    ],
    values: [
      { name: 'asc', displayName: t('queryBuilder.queryParam.queryOptions.admin.sort.values.asc') },
      { name: 'desc', displayName: t('queryBuilder.queryParam.queryOptions.admin.sort.values.desc') }
    ],
    used: false,
    value: ''
  },
  {
    name: 'pagination',
    displayName: '',
    type: 'pagination',
    used: true,
    value: ''
  }
];

export default queryOptions;
